const unauthorizedListeners = new Set()

export function subscribeToUnauthorized(listener) {
  unauthorizedListeners.add(listener)
  return () => unauthorizedListeners.delete(listener)
}

export function notifyUnauthorized(error) {
  unauthorizedListeners.forEach((listener) => listener(error))
}
